export * from "./env";
export * from "./package";
export * from "./git";
export * from "./release";
export * from "./util";

// verify environment and configure NPM
// for each lerna package, or the standalone package
//   get registry data (which might not exist if not published)
//   get package release options from RELEASE.yml
//   get local package dependencies
//   determine release type: major, minor, patch, skip
//     release options contains breaking, features and fixes
//     deep dependencies with a release is a patch
//   figure out versions
//     start with anchor version, specified in options or the latest
//     resolve the pivot version, which is the latest existing in range
//     calculate the next version, by bumping the pivot version
//   gather up all commits since the pivot release
//   build a detailed report with sanity checks
// prep repo for publish
//   append changes to CHANGELOG.md
//   clean up RELEASE.yml
//   commit changes and tag in git
// publish all packages to NPM
//   modify the package.json with new versions
//   perform the publish, releasing under temporary dist-tag
// after packages publish
//   switch temp dist-tag to latest
//   push the git commit
//   create a github release from tag
